export const navigationData = {
  phone: '+91 97694 15432',
  phoneLink: '919769415432',
  alternatePhone: '+91 97694 15432',
  telephone: '022-35764548',
  email: 'akylegalconsultants@gmail.com',
  address: {
    line1: 'Chamber No. 01, Building No. 03, Sector-5,',
    line2: 'Shanti Garden, Near MBVV Police Commissioner Office,',
    line3: 'Mira Road (E), Thane-401 107'
  },
  navLinks: [
    { name: 'Home', path: '/', exact: true },
    { 
      name: 'About Us', 
      path: '/about',
      dropdown: [
        { name: 'The Firm', path: '/about/firm' },
        { name: 'The Leadership', path: '/about/leadership' }
      ]
    },
    { 
      name: 'Practices', 
      path: '/practices',
      dropdown: [
        { name: 'Family Matters', path: '/practices/family-matters' },
        { name: 'Civil Matters', path: '/practices/civil-matters' },
        { name: 'Criminal Matters', path: '/practices/criminal-matters' }
      ]
    },
    { name: 'Documentations', path: '/documentations', exact: true },
    { name: 'Contact Us', path: '/contact', exact: true },
    
  ],
  socialLinks: [
    { name: 'Facebook', icon: 'facebook', url: '#' },
    { name: 'Twitter', icon: 'twitter', url: '#' },
    { name: 'LinkedIn', icon: 'linkedin', url: '#' },
    { name: 'Instagram', icon: 'instagram', url: '#' }
  ]
};